module.exports = __webpack_public_path__ + "img/ico-results.b4e19fd4.svg";